import {AuthoringGuideLevelModelV1} from 'resources/GeneratedModels/AuthoringGuideLevel/AuthoringGuideLevelModel.v1';

import {extensions} from './authoringGuideLevel.extensions';

AuthoringGuideLevelModelV1.extend(extensions);

export {AuthoringGuideLevelModelV1};
